import $ from 'jquery';
import 'slick-carousel';

const Gallery = (el) => {
    $(el).slick({
        infinite: false,
        appendArrows: $(el).parent().find('.js-gallery-arrows'),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1,
                },
            },
        ],
    });
};

$('.js-gallery-all').on('click', (e) => {
    $(e.currentTarget).parent().find('.js-gallery').slick('unslick');
    $(e.currentTarget).hide();
    $(e.currentTarget).parent().addClass('gallery--all');
});

export default Gallery;
